import type { FC } from 'react';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { MenuItem, Select } from '@mui/material';

import { TagCloudContext } from 'src/components/dashboard/DashboardContext/TagCloudContext';
import type { SentimentFilterValues } from 'src/components/dashboard/hooks/useTagsQuery';
import { TagSentimentFilter } from 'src/components/dashboard/hooks/useTagsQuery';

import { styles } from './index.styles';

export const TAG_CLOUD_DROPDOWN_TEST_ID = 'tag-cloud-dropdown';

const TagCloudDropdown: FC = () => {
  const { t } = useTranslation('dashboard');
  const { setSentimentFilter, sentimentFilter } = useContext(TagCloudContext);

  const tagCloudDropdownData: {
    label: string;
    value: SentimentFilterValues;
  }[] = [
    { label: t('TagCloud.allSentiments'), value: TagSentimentFilter.ALL },
    {
      label: t('TagCloud.positiveTopics'),
      value: TagSentimentFilter.POSITIVE,
    },
    {
      label: t('TagCloud.neutralTopics'),
      value: TagSentimentFilter.NEUTRAL,
    },
    {
      label: t('TagCloud.negativeTopics'),
      value: TagSentimentFilter.NEGATIVE,
    },
  ];

  return (
    <Select
      value={sentimentFilter}
      data-test-id={TAG_CLOUD_DROPDOWN_TEST_ID}
      sx={styles.tagCloudDropdown}
      onChange={(e) =>
        setSentimentFilter(e.target.value as SentimentFilterValues)
      }
      MenuProps={{
        PaperProps: {
          sx: styles.tagCloudMenuProps,
        },
      }}
    >
      {tagCloudDropdownData.map(({ label, value }, i) => (
        <MenuItem
          key={i}
          value={value}
          sx={styles.tagCloudDropdownItem}
          data-test-id={`${TAG_CLOUD_DROPDOWN_TEST_ID}-${value}`}
        >
          {label}
        </MenuItem>
      ))}
    </Select>
  );
};

export default TagCloudDropdown;
